import axios from "axios";
import i18n from "../../i18n";
import { dayStart, dayEnd } from "../../utils/dateRange";

const actions = {
  approveIncidentReport(context, { id }) {
    return axios
      .post("incidentReport/" + id + "/approve")
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.proofedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  rejectIncidentReport(context, { id, reason }) {
    return axios
      .post("incidentReport/" + id + "/reject", { reason })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.rejectedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getIncidentReportVersions(context, id) {
    return axios
      .get("incidentReport/" + id + "/versions")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return { versions: [], currentVersion: 0, canProof: false };
      });
  },

  bulkDeleteIncidentReports(context, ids) {
    return axios
      .post("incidentReport/bulk-delete", { ids })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("incidentReports.bulk.deletedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getIncidentReportYearCounts(context) {
    return axios
      .get("incidentReport/yearCounts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  getIncidentReportMonthCounts(context, year) {
    return axios
      .get("incidentReport/monthCounts", { params: { year } })
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  createIncidentReport(context, value) {
    return axios
      .post("incidentReport", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("incidentReports.createdMessage", {
            name: getIncidentReportName(r),
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createIncidentReportByQrCode(context, value) {
    return axios
      .post(`incidentReport/qrCode/${value.qrCodeKey}`, value.incidentReport)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("incidentReports.createdMessage", {
            name: getIncidentReportName(r),
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteIncidentReport(context, val) {
    return axios
      .delete("incidentReport/" + val.id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("incidentReports.deletedMessage"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateIncidentReport(context, value) {
    return axios
      .put("incidentReport/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("incidentReports.updatedMessage", {
            name: getIncidentReportName(r),
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleIncidentReport(context, id) {
    return axios
      .get("incidentReport/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAllIncidentReports(context) {
    return axios
      .get("incidentReport")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getIncidentReportStats(context) {
    return axios
      .get("incidentReport/stats")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createIncidentReportPdf(context, value) {
    return axios
      .get(
        "incidentReport/pdf?start=" +
          dayStart(value.start).toISOString() +
          "&end=" +
          dayEnd(value.end).toISOString(),
      )
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  createIncidentReport2Pdf(context, id) {
    return axios
      .get(`incidentReport2/${id}/pdf`)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  newIncidentReportQrCode(context) {
    return axios
      .post("incidentReport/qrCode")
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("incidentReports.qrCreated"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  deleteIncidentReportQrCode(context) {
    return axios
      .delete("incidentReport/qrCode")
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("incidentReports.qrDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;

function getIncidentReportName(response) {
  console.log(response);
  if (response.data.incidentReportType === "long") {
    const { firstName, lastName } =
      response.data.longIncidentReport?.insuredPerson;
    return `${firstName ?? ""}${lastName ? " " + lastName : ""}`;
  } else {
    return response.data.name;
  }
}
